export default {
  SET_PROFILE (state, profile) {
    state.profile = profile
  }
}
